const LoansType = {
  "A": "ordinario",
  "B": "ordinario",
  "C": "ordinario",
  "RV1": "vivienda",
  "RV2": "vivienda",
  "RV3": "vivienda",
  "RV4": "vivienda",
  "RV5": "vivienda",
  "RV6": "vivienda",
  "D": "especial",
  "E": "especial",
  "F": "especial",
  "G": "especial",
  "H": "especial",
  "I": "especial",
  "J": "especial",
  "K": "especial",
  "L": "especial",
  "D1": "especial",
  "D2": "especial",
  "A1": "auto",
  "A2": "auto",
};

const LoansTypeDB = {
  "A": "ordinario",
  "B": "ordinario",
  "C": "ordinario",
  "RV1": "ordinario",
  "RV2": "ordinario",
  "RV3": "ordinario",
  "RV4": "ordinario",
  "RV5": "ordinario",
  "RV6": "ordinario",
  "D": "especial",
  "E": "especial",
  "F": "especial",
  "G": "especial",
  "H": "especial",
  "I": "especial",
  "J": "especial",
  "K": "especial",
  "L": "especial",
  "D1": "especial",
  "D2": "especial",
  "A1": "auto",
  "A2": "auto",
};

const documentsType = {
  "IO": "Identificacion oficial",
  "CD": "Comprobante de domicilio",
  "TALON": "Talon de cheques",
  "SOLCRED": "Solicitud de credito",
  "CRED17": "Credencial seccion 17",
  "COTAUTO": "Cotizacion auto"
};

const largeMonths = {
  "01": "Enero",
  "02": "Febrero",
  "03": "Marzo",
  "04": "Abril",
  "05": "Mayo",
  "06": "Junio",
  "07": "Julio",
  "08": "Agosto",
  "09": "Septiembre",
  "10": "Octubre",
  "11": "Noviembre",
  "12": "Diciembre"
};

const numericMonths = {
  "Enero": "01",
  "Febrero": "02",
  "Marzo": "03",
  "Abril": "04",
  "Mayo": "05",
  "Junio": "06",
  "Julio": "07",
  "Agosto": "08",
  "Septiembre": "09",
  "Octubre": "10",
  "Noviembre": "11",
  "Diciembre": "12"
};

const descriptionRequestText = {
  "pendiente": "Solicitudes Pendientes",
  "documento_cargado": "Solicitudes Pendientes",
  "aceptado": "Solicitudes Aceptadas",
  "rechazado": "Solicitudes Rechazadas",
}

const documentsAbbreviation = {
  "ADD": "Original o copia certificada del acta de defunción del Socio",
  "AND": "Original o copia certificada del acta de nacimiento del Socio",
  "ISD": "Identificación del Socio",
  "CPD": "Ultimo comprobante de pago del Socio",
  "CTD": "Copia de la Cédula Testamentaria",
  "IOD": "Identificación oficial del Beneficiario",
  "ECN": "Estado de cuenta",
  "BSEN": "Baja al sector educativo",
  "ISN": "Identificación del Socio",
  "ECDI": "Estado de cuenta",
  "IODI": "Identificación Oficial",
  "RAEC": "Estado de cuenta para renuncia al ahorro",
  "RATALON": "Talon para renuncia al ahorro",
  "RAIO": "Identificación oficial para renuncia al ahorro",
  "RAAD": "Acta de defunción para renuncia al ahorro"
}

export {
  LoansType,
  LoansTypeDB,
  largeMonths,
  numericMonths,
  descriptionRequestText,
  documentsAbbreviation
}